import { DateTimePickerInput } from "@hawkins/components";
import { useField } from "formik";
import React, { useCallback } from "react";
import { isValidDate } from "../../utils";
const FormikDateTimePickerInput = ({
  errorMessageInvalid,
  inputProps,
  name,
  onBlur,
  onSelectedChange,
  onInputValueChange,
  ...rest
}) => {
  const [{ onChange, ...fieldRest }, meta, helpers] = useField(name);
  const handleBlur = useCallback(
    (event) => {
      helpers.setTouched(true);
      if (onBlur) {
        onBlur(event);
      }
    },
    [helpers, onBlur]
  );
  const handleSelected = useCallback(
    (newSelected) => {
      if (meta.error === errorMessageInvalid) {
        helpers.setError(void 0);
      }
      const formikValue = isValidDate(newSelected) ? newSelected : void 0;
      helpers.setValue(formikValue);
      onSelectedChange == null ? void 0 : onSelectedChange(newSelected);
    },
    [errorMessageInvalid, helpers, meta.error, onSelectedChange]
  );
  return /* @__PURE__ */ React.createElement(
    DateTimePickerInput,
    {
      ...fieldRest,
      inputProps: {
        ...inputProps,
        validationMessage: meta.touched && !!meta.error ? meta.error : void 0,
        validationStatus: meta.touched && !!meta.error ? "error" : void 0
      },
      onBlur: handleBlur,
      onSelectedChange: handleSelected,
      selected: fieldRest.value,
      ...rest
    }
  );
};
FormikDateTimePickerInput.defaultProps = {
  errorMessageInvalid: "Invalid"
};
export {
  FormikDateTimePickerInput
};
//# sourceMappingURL=FormikDateTimePickerInput.js.map
